<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 14:51:10
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-01-03 16:14:15
-->
<template>
  <div class="examinee">
    <div class="title">
      添加考试人员
    </div>
    <div v-if="!isReadOnly" class="userImport">
      <el-button type="text" @click="downloadTemp">用户模板下载</el-button>
      <el-upload
        action=""
        :http-request="fileRequestUserImport"
        accept=".xls,.xlsx"
        :limit="1"
        :file-list="fileList"
      >
        <el-button type="primary">用户导入</el-button>
      </el-upload>
    </div>
    <div class="examinee-table">
      <table-list
        :loading="loading"
        :data="userList"
        :pager="pager"
        :search-form="searchForm(this)"
        :columns="columns(this)"
        :footer-btns="footerBtns(this)"
        :operates="operates(this)"
        :options="{ selection: true, operatesWidth: 120 }"
        @search="onSearch"
        @selectionChange="handleSelectionChange"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></table-list>
    </div>
  </div>
</template>
<script>
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    icon: 'el-icon-download',
    method: _this.exportTable,
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'id',
    label: '考试人员ID',
    minWidth: 100,
  },
  {
    prop: 'name',
    label: '考生姓名',
    minWidth: 80,
  },
  {
    prop: 'sexName',
    label: '性别',
    minWidth: 60,
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 110,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 170,
  },
  {
    prop: 'admissionTicketId',
    label: '准考证',
    minWidth: 170,
  },
  {
    prop: 'company',
    label: '单位名称',
    minWidth: 150,
    twoLines: true,
  },
  {
    prop: 'creatorName',
    label: '添加人',
    minWidth: 80,
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: 150,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: 'ID/姓名/手机号/身份证/准考证/单位',
    noIcon: true,
    prop: 'keyWord',
  },
  {
    label: '添加时间',
    placeholder: '添加时间',
    type: 'picker',
    prop: 'createTime',
  },
  {
    label: '添加人',
    type: 'select',
    prop: 'creatorId',
    children: _this.adminList.map(item => ({
      value: item.key,
      label: item.value,
    })),
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleDelete,
    label: '删除',
    isShow: () => !_this.isReadOnly,
  },
]
import TableList from '@/components/TableList'
import {
  examUserTempDownload,
  examUserImport,
  examUserList,
  examUserDel,
  examUserExport,
  filterAdminList,
} from '@/api/exam'
import to from 'await-to'
export default {
  name: 'Subject',
  components: { TableList },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      subjectList: [],
      searchForm,
      columns,
      operates,
      footerBtns,
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      userList: [],
      fileList: [],
      selectList: [],
      adminList: [],
    }
  },
  mounted() {
    this.getUserList()
    this.getAdminList()
  },
  methods: {
    async getUserList() {
      const { current, size } = this.pager
      const [res, err] = await to(
        examUserList({ current, size, ...this.queryParams, examPlanId: this.$route.params.id }),
      )
      if (err) return this.$message.warning(err.msg)
      this.userList = res.data.list
      this.pager.total = res.data.total
    },
    async getAdminList() {
      const [res, err] = await to(filterAdminList({}))
      if (err) return this.$message.warning(err.msg)
      this.adminList = res.data
    },
    handleDelete(row) {
      this.$confirm('你确认要删除吗?', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            examUserDel({
              examPlanId: this.$route.params.id,
              id: row.id,
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getUserList()
        })
        .catch(() => {})
    },
    async fileRequestUserImport(file) {
      const params = new FormData() //创建FormData
      params.append('file', file.file)
      params.append('planId', this.$route.params.id)
      const [, err] = await to(examUserImport(params))
      this.fileList = []
      if (err)
        return this.$message({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          message: err.msg,
        })
      this.$message.success('导入成功')
      this.getUserList()
    },
    async downloadTemp() {
      const [res, err] = await to(examUserTempDownload())
      if (err) return this.$message.error(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '用户模板.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleSelectionChange(row) {
      this.selectList = row
    },
    //导出
    async exportTable() {
      let arr = []
      if (this.selectList.length) this.selectList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        examUserExport({
          current,
          size,
          ids: arr,
          ...this.queryParams,
          examPlanId: this.$route.params.id,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '考试人员.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      if (queryParams.createTime && queryParams.createTime.length) {
        queryParams.createBeginTime = queryParams.createTime[0]
        queryParams.createEndTime = queryParams.createTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.createBeginTime = undefined
        queryParams.createEndTime = undefined
      }
      this.getUserList()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getUserList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getUserList()
    },
  },
}
</script>
<style lang="scss" scoped>
.examinee {
  height: 100%;
  .title {
    height: 78px;
    line-height: 78px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #e8ebf2;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-button {
      width: 80px;
      height: 36px;
      background: #3671bf;
      border-radius: 2px;
    }
  }
  .userImport {
    padding: 20px 20px 0 20px;
    display: flex;
    .el-button {
      width: auto;
      height: 36px;
      padding: 0 12px;
      margin: 0;
      margin-right: 16px;
    }
    > .el-button {
      padding: 0;
    }
  }
  .examinee-table {
    padding: 20px;
    height: calc(100% - 164px);
    /deep/.table-list {
      .form {
        padding: 0;
        .el-input {
          input {
            padding-right: 12px;
          }
        }
      }
    }
  }
}
</style>
